module.exports = __webpack_public_path__ + "img/exchange.4d60993a.png";